import { Container, Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Link } from "react-router-dom";
import AppPageHeader from "../../../components/Headers/AppPageHeader";
import useToggle from "../../../hooks/useToggle";
import CreateCloudDrawer from "./CreateCloudDrawer";
import AppHelmet from "../../../components/AppComponents/AppHelmet";
import TableCloudsView from "./TableCloudsView";

const CloudListView = ({
  urlStart,
  mode = "supp",
}: {
  urlStart?: string;
  mode: "mc" | "supp";
}) => {
  const [createCloudDrawer, toggleCreateCloudDrawer] = useToggle();
  urlStart = urlStart || "/supportal";

  return (
    <>
      <AppHelmet title="Clouds - GrowthCloud.com" />
      <div className="header">
        <Container fluid>
          <AppPageHeader
            title="Clouds"
            description="Manage the clouds inside this instance"
            actionButtonName="New"
            actionButtonColor="primary"
            action={mode === "supp" ? toggleCreateCloudDrawer : undefined}
            breadcrumbs={
              <Breadcrumb
                className="tw:pt-2"
                listClassName="tw:p-0 tw:m-0 tw:bg-transparent"
              >
                <BreadcrumbItem>
                  <Link to={urlStart}>
                    <i className="mdi mdi-lifebuoy" />
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>Clouds</BreadcrumbItem>
              </Breadcrumb>
            }
          />
        </Container>
      </div>
      <TableCloudsView urlStart={urlStart} />
      <CreateCloudDrawer
        open={createCloudDrawer}
        onClose={toggleCreateCloudDrawer}
        isSupportal
      />
    </>
  );
};

export default CloudListView;
